import styled from 'styled-components';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: block;
    margin-right: 30px;
    margin-bottom : 10px;
    &:last-child {
        margin-right: 0;
    }
`;

export const Value = styled.div`
    display: block;
    font-size: 44px;
    line-height: 1.33;
    font-family: 'robotoregular';
    span {
        font-size: 36px;
    }
    @media (max-width: 1279px) {
        font-size: 32px;
        span {
            font-size: 27px;
        }
    }
    @media (max-width: 530px) {
        font-size: 24px;
        span {
            font-size: 18px;
        }
    }
`;

export const Text = styled.div`
    display: block;
    font-size: 24px;
    line-height: 1.33;
    font-family: ${FONTS.light};
    @media (max-width: 1279px) {
        font-size: 20px;
    }
    @media (max-width: 530px) {
        font-size: 16px;
    }
`;
